import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore';
import type { ExampleRenterReport } from './types';
import type { ClickstreamPayload, ZrmUserInfo } from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackEvent = analytics.createTrackEvent('CLICKSTREAM');

// todo: remove examples when you set up your real events
export const trackRenterEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ExampleRenterReport>>(
  'CLICKSTREAM',
);

// we have some shared types in the clickstream module. Only add more if yours are truly "shared"
export const trackZrmUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>(
  'CLICKSTREAM',
);
